<template>
  <WsUpdateDialog
    ref="updateDialog"
    :label="label"
    :fields="fields"
    :modelName="modelName"
    :errorMessages="errorMessages"
    :customBtns="customBtns"
    :isCloseScrollTop="isCloseScrollTop"
    :isLoading="isLoading"
    @custom-emit="$_onCustomAction($event)"
    @update-submit="$_onSubmit($event)"
    @read="$_onRead($event)"
  >
    <template v-slot:content="{modelData, updateData, dialog}">
      <WsCompareTable
        v-if="dialog"
        :fields="fields"
        :modelData="modelData"
        :updateData="updateData"
        :errorMessages="errorMessages"
        :isUpdate="true"
        :getValueFunction="getCompareDialogValueFunction"
        @input="$_onInput($event.fieldKey,$event.value)"
        @input-item="$_onInput($event.fieldKey,$event.value)"
      />
    </template>
  </WsUpdateDialog>
</template>

<script>
export default {
  name: 'WsUpdateDialogCompare',
  props: {
    errorMessages: {
      type: Object,
      default: null,
    },
    modelName: String,
    label: {
      type: String,
      default: null,
    },
    customTitle: {
      type: Boolean,
      default: false,
    },
    fields: Object,
    customBtns: {
      type: Object,
      default: function (){
        return {}
      }
    },
    getCompareDialogValueFunction: {
      type: Object,
    },
    isCloseScrollTop: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  methods:{
    $_onSubmit($event) {
      this.$emit("update-submit",$event);
    },
    $_onRead($event) {
      this.$emit("read", $event)
    },
    open(item) {
      this.$refs.updateDialog.open(item)
    },
    $_onInput(fieldKey, $event) {
      this.$refs.updateDialog.$_onInput(fieldKey, $event)
    },
    startLoading() {
      this.$refs.updateDialog.startLoading()
    },
    stopLoading() {
      this.$refs.updateDialog.stopLoading()
    },
    close() {
      this.$refs.updateDialog.close()
    },
    $_onCustomAction($event){
      this.$emit('custom-emit', $event)
    }
  }
}
</script>

<style>

</style>